import SyncStatusTab from './syncStatusTab.view.js';

export default SyncStatusTab;
